// removed by extract-text-webpack-plugin
module.exports = {"heading":"theme__heading___1IVnj","fadeUp":"theme__fadeUp___1KYUk","chooseArgument":"theme__chooseArgument___1lQVp","question":"theme__question___2x-tA","questionImage":"theme__questionImage___2k_RG","imageLoaded":"theme__imageLoaded___1_gJi","questionText":"theme__questionText___eLLlo","lateFadeUp":"theme__lateFadeUp___1FYo3","lateFadeIn":"theme__lateFadeIn___1Kx8Y"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/ChooseArgument/theme.scss
// module id = 1269
// module chunks = 0